// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nmjakogetnzrfluicvdh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5tamFrb2dldG56cmZsdWljdmRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQwMDE1ODQsImV4cCI6MjA1OTU3NzU4NH0.vWspCejNJm19WGtCTtTh2UmmKuwHNIzgUL6ZR-lVE-o";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);